import { render, staticRenderFns } from "./WeldIcon.vue?vue&type=template&id=4b34570f&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b34570f')) {
      api.createRecord('4b34570f', component.options)
    } else {
      api.reload('4b34570f', component.options)
    }
    module.hot.accept("./WeldIcon.vue?vue&type=template&id=4b34570f&", function () {
      api.rerender('4b34570f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WeldIcon.vue"
export default component.exports